import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

// The Messages page (Nic 2026-10-22): every Sales and Onboarding message,
// worded for where each person came from. messages:manage only.

const BASE = '/messages';
const KEY = ['messages'];

// Every message (with where it's used and any problems), the sources, the
// fill-ins, the partners and events, and the length limits.
export const useMessages = () => useQuery(KEY, async () => (await axios.get(BASE)).data, { refetchOnWindowFocus: true });

// One message's history.
export const useMessageHistory = (messageId, enabled) =>
  useQuery([...KEY, 'history', messageId], async () => (await axios.get(`${BASE}/${messageId}`)).data, {
    enabled: !!messageId && !!enabled,
  });

const useWrite = (fn) => {
  const queryClient = useQueryClient();
  return useMutation(fn, {
    onSuccess: () => {
      queryClient.invalidateQueries(KEY);
      // The cadence editor lists the cadence messages as its scripts.
      queryClient.invalidateQueries(['cadence-scripts']);
    },
  });
};

export const useCreateMessage = () => useWrite(async (body) => (await axios.post(BASE, body)).data);

export const useSaveMessage = () =>
  useWrite(async ({ messageId, ...body }) => (await axios.put(`${BASE}/${messageId}`, body)).data);

export const useDeleteMessage = () => useWrite(async ({ messageId }) => (await axios.delete(`${BASE}/${messageId}`)).data);

export const useRestoreMessage = () =>
  useWrite(async ({ messageId, historyId }) => (await axios.post(`${BASE}/${messageId}/restore`, { historyId })).data);
